module.exports = __webpack_public_path__ + "static/media/AlKhori_dealerhighlight_desktop_hero.06069059.jpg";